import * as msal from '@azure/msal-browser'
import jwtDecode from 'jwt-decode'

import { loginRequest, msalConfig } from '@config/authorization'

interface UserTokenData {
  name: string
  /**
   * Not always present, sometimes it might be called unique_name
   */
  email?: string

  /**
   * The user email
   */
  unique_name?: string
}

export const SSOInstance = new msal.PublicClientApplication(msalConfig)

const getActiveAccount = () => {
  let account = SSOInstance.getActiveAccount()

  if (account) {
    return account
  }

  const accounts = SSOInstance.getAllAccounts()
  account = accounts.find(
    // an user can be logged into multiple azure accounts
    // check if the token was issued to our app
    (acc) => acc.idTokenClaims && acc.idTokenClaims.aud === msalConfig.auth.clientId,
  )

  if (!account) {
    throw Error('No active account! Verify a user has been signed in.')
  }

  SSOInstance.setActiveAccount(account)
  return account
}

export const getToken = async () => {
  const account = getActiveAccount()
  const { accessToken } = await SSOInstance.acquireTokenSilent({
    ...loginRequest,
    account,
  })

  return accessToken
}

export const userInfo = async () => {
  const accessToken = await getToken()
  const decodedToken = jwtDecode<UserTokenData>(accessToken)

  return {
    displayName: decodedToken.name,
    email: decodedToken.email || decodedToken.unique_name,
  }
}
